export default __webpack_public_path__ + "static/elderSubvention-num-client-e6d302d17e276723f46b98fad0e21214.png";